export default "__VITE_ASSET__BJODq1u___"